<template>
  <ImportExport :title="$t('keywords.rest_to_soap')" type="resttosoaplib" :headers="headers" v-on="$listeners">
    <template #item.nameMethod="{ item }">
      <v-text-field v-model="item.nameMethod" style="margin-bottom: -2.3vh" outlined dense :rules="alphaNumericRules(item.nameMethod)" />
    </template>

    <template #item.active="{ item }">
      <v-switch v-model="item.active" />
    </template>

    <template #item.routingkey="{ item }">
      <RoutingkeySelect v-model="item.routingkey" style="width: 10.5vw; margin-bottom: -3%" :rules="requiredRules(item.routingkey)" hint="" />
    </template>
  </ImportExport>
</template>

<script>
import ImportExport from '../core/ImportExport.vue'
import RoutingkeySelect from '../core/RoutingkeySelect.vue'
import { alphaNumericRules, requiredRules } from '../../utils/rules'
import LocalStorageService from '../../services/LocalStorageService'

export default {

  components: { ImportExport, RoutingkeySelect },

  data: () => ({
    alphaNumericRules,
    requiredRules
  }),

  computed: {
    headers () {
      return [
        {
          text: this.$t('keywords.method_name'),
          value: 'nameMethod'
        },
        {
          text: this.$t('check.active'),
          value: 'active'
        },
        {
          text: this.$t('core.routing_key'),
          value: 'routingkey',
          show: LocalStorageService.isPlatform()
        }
      ].filter(i => i.show ?? true)
    }
  }

}
</script>
